// Tracking steps for a sub-order — logic extracted VERBATIM from
// components/TrackingTimeline so V1 (timeline) and V2 (account area) render the
// same rules (MC-50..MC-52). Icons/markup stay in the components.
export function buildTrackingSteps(subOrder, order) {
  const history = subOrder.history

  const statusList = [
    { status: 'NEW', color: '#309740', sort: 1, label: 'Pedido realizado', disabled: true, hidden: false },
    { status: 'PW', color: '#CDB04C', sort: 2, label: 'Aguardando pagamento', disabled: true, hidden: false },
    { status: 'AP', color: '#309740', sort: 3, label: 'Pagamento confirmado', disabled: true, hidden: false },
    { status: 'PP', color: '#309740', sort: 4, label: 'Pedido em separação', disabled: true, hidden: false },
    { status: 'PF', color: '#309740', sort: 5, label: 'Aguardando transportadora', disabled: true, hidden: false },
    { status: 'PT', color: '#309740', sort: 6, label: 'Entregue à transportadora', disabled: true, hidden: false },
    { status: 'PE', color: '#309740', sort: 8, label: 'Entregue', disabled: true, hidden: false },
    { status: 'C', color: '#ED1B2F', sort: 9, label: 'Pedido cancelado', disabled: true, hidden: false },
  ]

  const isCanceled = history.some(item => item.status === 'C' || item.status === 'CM')
  const isAwaitPayment = history.some(item => item.status === 'PW' || item.status === 'BAP')
  const paymentConfirmed = history.some(item => item.status === 'AP')

  statusList.map(x => {
    if (isAwaitPayment) {
      if (x.status === 'PW') {
        x.disabled = false
        x.color = '#CDB04C'
      }
    }

    if (x.status === 'PW') {
      if (!paymentConfirmed) {
        x.color = '#CDB04C'
        x.disabled = false
      } else {
        x.color = '#309740'
        x.disabled = false
      }
    }

    if (x.status === 'C') {
      if (history.some(i => i.status === 'CM')) {
        x.label = 'Pedido cancelado manualmente'
      } else if (history.some(i => i.status === 'C')) {
        x.label = 'Pedido cancelado'
      }
      x.disabled = false
    }
    return x
  })

  const sortedStatuslist = statusList.sort((a, b) => a.sort - b.sort).filter(x => !x.hidden)

  const filteredStatusList = sortedStatuslist.filter(status => {
    if (isCanceled) return status.status === 'NEW' || status.status === 'C'

    if (!subOrder.school_is_b2c) return status.status === 'NEW' || status.status === 'PW' || status.status === 'AP'

    if (subOrder.business_line_id === 7 || !subOrder.school_is_b2c)
      return status.status === 'NEW' || status.status === 'PW' || status.status === 'AP'

    return status.status !== 'C'
  })

  for (let status of filteredStatusList) {
    for (let item of history) {
      if (status.status === item.status) {
        status.disabled = false
        status.changed = item.changed
      }
    }
  }

  // para pedidos antes da campanha 11, não temos histórico — habilitamos os status
  if (subOrder.history.length == 0 && order.campaign_id < 11) {
    if (subOrder.status == 'AP' || subOrder.status == 'PE') {
      statusList.map(x => {
        x.disabled = false
        x.color = '#309740'
        return x
      })
    }
  }

  return filteredStatusList
}
